import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Collapse from '@mui/material/Collapse';
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import jwt_decode from "jwt-decode";
import NumberFormat from 'react-number-format';
import {
  Alert, Autocomplete, ButtonGroup, TextField, Tooltip,
  Button, Grid, InputAdornment, styled
} from '@mui/material';
import { NumberFormatMoney } from '../useForm';
import format from 'format-number'
import { Can } from '@casl/react';
import { Ability } from "@casl/ability";
import { Link, useParams } from 'react-router-dom'
import TipsAndUpdatesTwoToneIcon from '@mui/icons-material/TipsAndUpdatesTwoTone';
import PictureAsPdfTwoToneIcon from '@mui/icons-material/PictureAsPdfTwoTone';

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  '&:last-child td, &:last-child th': {
    border: 0,
  },
}));

function Row(props) {
  const { row, partidas, partidasParanoid, ability, idUsuario, idResponsable, planeacion } = props;
  const [open, setOpen] = useState(false);
  const [openMensaje, setOpenMensaje] = useState(false);
  const [mensaje, setMensaje] = useState('');
  const [nuevaPartidaProyecto, setNuevaPartidaProyecto] = useState({ idProyectoPlan: row.id })
  let respaldoPartidaProyecto
  const [montoMaximo, setMontoMaximo] = useState(0)

  const [loading, setLoading] = useState(false)
  const [editing, setEditing] = useState(false)
  const [montoExcedido, setMontoExcedido] = useState(false)
  const [elaboracionInforme, setElaboracionInforme] = useState(row.elaboracionInforme)
  const [planPresupuestal, setPlanPresupuestal] = useState({})
  const [severity, setSeverity] = useState('error')

  const porcentajePrioridad1 = Number(Number(1) - Number(process.env.REACT_APP_PRIORIDAD_DOS)).toFixed(2)
  const porcentajePrioridad2 = Number(process.env.REACT_APP_PRIORIDAD_DOS)

  const cargarPlan = async () => {
    //console.log(`row.idPlan ${row.idPlan}`)
    const res = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/planeacion/${row.idPlan}`, {
      method: "GET"
    }
    )

    if (res.status === 404) {
      setPlanPresupuestal({ idPlanPresupuestal: 0, montoMaximo: 0 })
      //console.log('regresó 404')
      return { idPlanPresupuestal: 0, montoMaximo: 0 }
    }

    else {
      //console.log('la planeación si existe')

      const data = await res.json()
      //console.log(data)
      setPlanPresupuestal(data)

      return data
    }


  }
  useEffect(() => {
    (async () => {
      await cargarPlan()
    })();
  }, []
  )

  const handleUpdate = async (partidaProyecto) => {
    partidaProyecto.montoPrevio = partidaProyecto.montoMaximo
    partidaProyecto.prioridad1MontoPrevio = partidaProyecto.prioridad1
    partidaProyecto.prioridad2MontoPrevio = partidaProyecto.prioridad2
    setNuevaPartidaProyecto({ ...partidaProyecto });
    setEditing(true)
    //console.log(partidaProyecto)
  }
  const handleSubmit = async (e, proyecto) => {
    e.preventDefault()

    setLoading(true)
    let montoMaximo = 0
    let prioridad1 = 0
    let prioridad2 = 0
    //console.log(`nuevaPartidaProyecto.montoMaximo ${nuevaPartidaProyecto.montoMaximo}`)
    if (nuevaPartidaProyecto.montoMaximo) {
      montoMaximo = isNaN(nuevaPartidaProyecto.montoMaximo) ? nuevaPartidaProyecto.montoMaximo.replace(/,/g, '') : nuevaPartidaProyecto.montoMaximo
      prioridad1 = isNaN(nuevaPartidaProyecto.prioridad1) ? nuevaPartidaProyecto.prioridad1.replace(/,/g, '') : nuevaPartidaProyecto.prioridad1
      prioridad2 = isNaN(nuevaPartidaProyecto.prioridad2) ? nuevaPartidaProyecto.prioridad2.replace(/,/g, '') : nuevaPartidaProyecto.prioridad2
      nuevaPartidaProyecto.montoMaximo = montoMaximo
      nuevaPartidaProyecto.prioridad1 = prioridad1
      nuevaPartidaProyecto.prioridad2 = prioridad2
    }
    else {
      nuevaPartidaProyecto.montoMaximo = 0
      nuevaPartidaProyecto.prioridad1 = 0
      nuevaPartidaProyecto.prioridad2 = 0
    }

    if (editing) {
      const res = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/partidasProyecto/${nuevaPartidaProyecto.idPartidaProyecto}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          "x-access-token": sessionStorage.getItem('token'),
          "perfil": sessionStorage.getItem('perfil')
        },
        body: JSON.stringify(nuevaPartidaProyecto)
      })
      const data = await res.json()
      //colocar un mensaje para orientar al usuario, se está validando desde sequelize
      if(res.status === 200)
        setSeverity('success')
      else
        setSeverity('error')
      if (data.message) {
        setOpenMensaje(true)
        setMensaje(`${data.message}`)
        setLoading(false)
        return
      }
      else {
        setOpenMensaje(false)
        const partidasProyecto = proyecto.partidaProyectos
        proyecto.partidaProyectos = partidasProyecto.filter(partidasProyecto => partidasProyecto.idPartidaProyecto !== nuevaPartidaProyecto.idPartidaProyecto)
        setEditing(false)
      }

    }
    else {
      let existePartida = false
      //verificar si existen partidaProyectos podría estar vacía
      if (row.partidaProyectos)
        if (row.partidaProyectos.length > 0) {
          row.partidaProyectos.map((partida) => {
            //console.log(`partida.id === nuevaPartidaProyecto.idPartidaCatalogo ${partida.idPartidaCatalogo === nuevaPartidaProyecto.idPartidaCatalogo} ${partida.idPartidaCatalogo} ${nuevaPartidaProyecto.idPartidaCatalogo}`)
            if (partida.idPartidaCatalogo === nuevaPartidaProyecto.idPartidaCatalogo)
              existePartida = true
          })
          if (existePartida) {
            setSeverity('error')
            setMensaje(`Esa partida ya tiene presupuesto asignado`)
            setOpenMensaje(true)
            setLoading(false)
            return
          }
        }
      const res = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/partidasProyecto`, {
        method: "POST",
        body: JSON.stringify(nuevaPartidaProyecto),
        headers: {
          "Content-Type": "application/json",
          "x-access-token": sessionStorage.getItem('token'),
          "perfil": sessionStorage.getItem('perfil')
        },
      })

      const data = await res.json()
      //colocar un mensaje para orientar al usuario, se está validando desde sequelize
      if(res.status === 200)
        setSeverity('success')
      else
        setSeverity('error')
      if (data.message) {
        setOpenMensaje(true)
        setMensaje(`${data.message}`)
        setLoading(false)
        return
      }
      else {
        //console.log(`Agregada ${data.idPartidaProyecto}`)
        nuevaPartidaProyecto.idPartidaProyecto = data.idPartidaProyecto
        setOpenMensaje(false)
      }
    }
    setLoading(false)

    respaldoPartidaProyecto = JSON.parse(JSON.stringify(nuevaPartidaProyecto))

    proyecto.partidaProyectos.push(respaldoPartidaProyecto)

    //navigate(0)
    //Limpiar la nueva partida que se usa en el formulario
    nuevaPartidaProyecto.prioridad2 = ''
    nuevaPartidaProyecto.prioridad1 = ''
    nuevaPartidaProyecto.montoMaximo = ''
    nuevaPartidaProyecto.idPartidaCatalogo = ''
    nuevaPartidaProyecto.montoPrevio = 0
    nuevaPartidaProyecto.prioridad1MontoPrevio = 0
    nuevaPartidaProyecto.prioridad2MontoPrevio = 0

    //Actualizar valores del proyecto para que se reflejen en la vista
    proyecto.montoAsignado = (Number(proyecto.montoAsignado) + Number(montoMaximo) - Number(respaldoPartidaProyecto.montoPrevio ? respaldoPartidaProyecto.montoPrevio : 0)).toFixed(2)
    proyecto.prioridad1Asignada = (Number(proyecto.prioridad1Asignada) + Number(prioridad1) - Number(respaldoPartidaProyecto.prioridad1MontoPrevio ? respaldoPartidaProyecto.prioridad1MontoPrevio : 0)).toFixed(2)
    proyecto.prioridad2Asignada = (Number(proyecto.prioridad2Asignada) + Number(prioridad2) - Number(respaldoPartidaProyecto.prioridad2MontoPrevio ? respaldoPartidaProyecto.prioridad2MontoPrevio : 0)).toFixed(2)
    proyecto.montoDisponible = (Number(proyecto.montoDisponible) - Number(montoMaximo) + Number(respaldoPartidaProyecto.montoPrevio ? respaldoPartidaProyecto.montoPrevio : 0)).toFixed(2)
    proyecto.prioridad1Disponible = (Number(proyecto.prioridad1Disponible) - Number(prioridad1) + Number(respaldoPartidaProyecto.prioridad1MontoPrevio ? respaldoPartidaProyecto.prioridad1MontoPrevio : 0)).toFixed(2)
    proyecto.prioridad2Disponible = (Number(proyecto.prioridad2Disponible) - Number(prioridad2) + Number(respaldoPartidaProyecto.prioridad2MontoPrevio ? respaldoPartidaProyecto.prioridad2MontoPrevio : 0)).toFixed(2)

    //Limpiar el Autocomplete
    //document.forms['guardar' + proyecto.id].getElementsByClassName('css-1glvl0p-MuiButtonBase-root-MuiIconButton-root-MuiAutocomplete-clearIndicator')[0].click()
  }

  const verificarPrioridad = async (elemento, montoMaximoPrioridadN, prioridadN, N, elemento2, montoMaximoPrioridadM, M) => {
    const valor = elemento.value.replace(/,/g, '')
    const nombre = elemento.name

    const montoMaximo = isNaN(nuevaPartidaProyecto.montoMaximo) ? nuevaPartidaProyecto.montoMaximo.replace(/,/g, '') : nuevaPartidaProyecto.montoMaximo

    setNuevaPartidaProyecto({ ...nuevaPartidaProyecto, [nombre]: valor, [prioridadN]: montoMaximo - valor })

    if (Number(valor) > Number(montoMaximo)) {
      setSeverity('error')
      setMensaje(`El monto de la Prioridad ${N} ${format({ prefix: '$' })(valor)} no debe superar al monto del proyecto ${format({ prefix: '$' })(montoMaximo)}`)
      setOpenMensaje(true)
      setMontoExcedido(true)
      elemento.style.color = 'red'
      return;
    }
    else {
      elemento.style.color = 'black'
      setMontoExcedido(false)
      setOpenMensaje(false)
    }

    if (Number(valor) > Number(montoMaximoPrioridadN)) {
      setSeverity('error')
      setMensaje(`Prioridad ${N} del proyecto ${format({ prefix: '$' })(Number(valor).toFixed(2))} no puede superar a Prioridad ${N} disponible del plan ${format({ prefix: '$' })(Number(montoMaximoPrioridadN).toFixed(2))}`)
      setOpenMensaje(true)
      setMontoExcedido(true)
      elemento.style.color = 'red'
      return;
    }
    else {
      elemento.style.color = 'black'
      setMontoExcedido(false)
      setOpenMensaje(false)
    }
    ////////////////////////////////////////////////
    const valor2 = montoMaximo - valor
    //console.log(`VALOR 2 = ${valor2} MONTO PRIORIDAD ${M} ${montoMaximoPrioridadM}`)

    if (Number(valor2) > Number(montoMaximo)) {
      setSeverity('error')
      setMensaje(`El monto de la Prioridad ${M} ${format({ prefix: '$' })(valor2)} no debe superar al monto del proyecto ${format({ prefix: '$' })(montoMaximo)}`)
      setOpenMensaje(true)
      setMontoExcedido(true)
      elemento2.style.color = 'red'
      return;
    }
    else {
      elemento2.style.color = 'black'
      setMontoExcedido(false)
      setOpenMensaje(false)
    }


    if (Number(valor2) > Number(montoMaximoPrioridadM)) {
      setSeverity('error')
      setMensaje(`Prioridad ${M} del proyecto ${format({ prefix: '$' })(Number(valor2).toFixed(2))} no puede superar a Prioridad ${M} disponible del plan ${format({ prefix: '$' })(Number(montoMaximoPrioridadM).toFixed(2))}`)
      setOpenMensaje(true)
      setMontoExcedido(true)
      elemento2.style.color = 'red'
      return;
    }
    else {
      elemento2.style.color = 'black'
      setMontoExcedido(false)
      setOpenMensaje(false)
    }
  }

  const handleDelete = async (id, proyecto) => {
    //Limpiar el formulario
    nuevaPartidaProyecto.prioridad2 = ''
    nuevaPartidaProyecto.prioridad1 = ''
    nuevaPartidaProyecto.montoMaximo = ''
    nuevaPartidaProyecto.idPartidaCatalogo = ''
    nuevaPartidaProyecto.montoPrevio = 0
    nuevaPartidaProyecto.prioridad1MontoPrevio = 0
    nuevaPartidaProyecto.prioridad2MontoPrevio = 0
    setLoading(true)
    try {
      const resDelete = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/partidasProyecto/${id}`, {
        method: "DELETE",
        headers: {
          "x-access-token": sessionStorage.getItem('token'),
          "perfil": sessionStorage.getItem('perfil')
        }
      })

      const res = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/proyectosPlan/proyecto/${proyecto.id}`, {
        method: "GET",
        headers: {
          "x-access-token": sessionStorage.getItem('token'),
          "perfil": sessionStorage.getItem('perfil')
        }
      })
      const data = await res.json()
      //console.log(`PROYECTO ${JSON.stringify(data)}`)
      // Actualizar los montos del proyecto al que pertenece la partida eliminada
      proyecto.montoAsignado = data.montoAsignado
      proyecto.prioridad1Asignada = data.prioridad1Asignada
      proyecto.prioridad2Asignada = data.prioridad2Asignada
      proyecto.montoDisponible = data.montoDisponible
      proyecto.prioridad1Disponible = data.prioridad1Disponible
      proyecto.prioridad2Disponible = data.prioridad2Disponible
      const partidasProyecto = proyecto.partidaProyectos
      //Quitar la partida eliminada del listado
      if (resDelete.status === 403) {
        setOpenMensaje(true)
        setSeverity('warning')
        setMensaje(`La sesión ha expirado, cierre su sesión (Botón LOGOUT) y vuelva a loguearse`)
        return
      }
      proyecto.partidaProyectos = partidasProyecto.filter(partidasProyecto => partidasProyecto.idPartidaProyecto !== id)

    } catch (error) {
      console.error(error)
    }
    setLoading(false)
  }

  const handleConcluirInforme = async (proyecto) => {
    const res = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/informeProyecto/concluirInforme/${proyecto.id}/${sessionStorage.getItem('idEntidad')}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": sessionStorage.getItem('token'),
        "perfil": sessionStorage.getItem('perfil')
      },
      body: JSON.stringify({ idRegistrante: idUsuario })
    })
    const data = await res.json()
    if(res.status === 200)
      setSeverity('success')
    else
      setSeverity('error')

    if (data.message) {
      setOpen(true)
      setOpenMensaje(true)

      setMensaje(data.message)
      if (data.message === 'Finalizó la elaboración del informe, se ha enviado el email para notificar a titular de la sección')
        setElaboracionInforme(2)
      setLoading(false)
      return
    }
  }


  return (
    <>
      <StyledTableRow sx={{ '& > *': { borderBottom: 'unset' } }}>
        <TableCell>
          <IconButton
            aria-label="expand row"
            size="small"
            onClick={() => setOpen(!open)}
          >
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>
        <TableCell component="th" scope="row" style={{ verticalAlign: 'top' }}>
          {row.clave}
        </TableCell>
        <TableCell align="justify" style={{ verticalAlign: 'top' }}>{row.descripcion}</TableCell>
        <TableCell align="right" style={{ verticalAlign: 'top', whiteSpace: 'pre' }}>
          <strong>Total: <NumberFormat value={Number(row.montoMaximo).toFixed(2)} displayType={'text'} decimalScale={2} thousandSeparator={true} prefix={'$'} /></strong><br />
          Prioridad 1: <NumberFormat value={Number(row.prioridad1).toFixed(2)} displayType={'text'} decimalScale={2} thousandSeparator={true} prefix={'$'} /><br />
          Prioridad 2: <NumberFormat value={Number(row.prioridad2).toFixed(2)} displayType={'text'} decimalScale={2} thousandSeparator={true} prefix={'$'} />

          {planPresupuestal.fase === 3 ?
            <><br /><Button variant='contained' style={{ marginTop: 20, backgroundColor: "darkgreen", color: 'white', width: '100%' }} onClick={() => { window.open(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/informeProyecto/mostrarReporteCierre/${row.id}`) }}>Reporte Cierre Planeación  <PictureAsPdfTwoToneIcon></PictureAsPdfTwoToneIcon></Button></> : <></>}

        </TableCell>
        {elaboracionInforme < 2 ?
          <>
            <TableCell align="right" style={{ verticalAlign: 'top', whiteSpace: 'pre' }}>
              <strong>Total: <NumberFormat value={Number(row.montoAsignado).toFixed(2)} displayType={'text'} decimalScale={2} thousandSeparator={true} prefix={'$'} /></strong><br />
              Prioridad 1: <NumberFormat value={Number(row.prioridad1Asignada).toFixed(2)} displayType={'text'} decimalScale={2} thousandSeparator={true} prefix={'$'} /><br />
              Prioridad 2: <NumberFormat value={Number(row.prioridad2Asignada).toFixed(2)} displayType={'text'} decimalScale={2} thousandSeparator={true} prefix={'$'} />

              {elaboracionInforme === 2 ?
                <><br /><Button variant='contained' style={{ marginTop: 20, backgroundColor: "darkgreen", color: 'white', width: '100%' }} onClick={() => { window.open(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/informeProyecto/mostrarInforme/${row.id}`) }}>Oficio <PictureAsPdfTwoToneIcon></PictureAsPdfTwoToneIcon></Button></> : <></>}
            </TableCell>
            <TableCell align="right" style={{ verticalAlign: 'top', whiteSpace: 'pre' }}>
              <strong>Total: <NumberFormat value={row.montoDisponible} displayType={'text'} decimalScale={2} thousandSeparator={true} prefix={'$'} /></strong><br />
              Prioridad 1: <NumberFormat value={row.prioridad1Disponible} displayType={'text'} decimalScale={2} thousandSeparator={true} prefix={'$'} /><br />
              Prioridad 2: <NumberFormat value={row.prioridad2Disponible} displayType={'text'} decimalScale={2} thousandSeparator={true} prefix={'$'} />
              {Number(row.montoDisponible) === Number(0) && Number(row.prioridad1Disponible) === Number(0) && Number(row.prioridad2Disponible) === Number(0) ? idUsuario === idResponsable && elaboracionInforme !== 2 ? <><br /><Button variant='contained' style={{ marginTop: 20, backgroundColor: "darkgreen", color: 'white', width: '100%' }} onClick={() => handleConcluirInforme(row)}>Concluir Informe</Button></> : <><br /><Button variant='contained' onClick={() => { setOpen(!open) }} style={{ marginTop: 20, backgroundColor: "darkgreen", color: 'white', width: '100%' }}>Informe Concluído</Button></> : <></>}

            </TableCell>
          </>
          : <></>
        }
      </StyledTableRow>
      <StyledTableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box sx={{ margin: 1 }}>
              <Typography variant="h6" gutterBottom component="div">
                Detalle Presupuestal
              </Typography>
              {row.partidaProyectos.length === 0 ? <Table size="small" aria-label="purchases">
                <TableHead>
                  <TableRow>
                    <TableCell>Aún no se ha asignado presupuesto a ninguna partida</TableCell></TableRow></TableHead></Table> :
                <Table size="small" aria-label="purchases">
                  <TableHead>
                    <TableRow>
                      <TableCell>Partida</TableCell>
                      <TableCell>Concepto</TableCell>
                      <TableCell align="right">Presupuesto Asignado</TableCell>
                      <TableCell align="right">Prioridad 1</TableCell>
                      <TableCell align="right">Prioridad 2</TableCell>
                      {idUsuario === idResponsable ? <TableCell align="right"></TableCell> : <></>}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {row.partidaProyectos.map((partidaRow) => (
                      partidasParanoid.length > 0 ?
                        <TableRow key={partidasParanoid.filter(partida => partida.id === partidaRow.idPartidaCatalogo)[0] ? partidasParanoid.filter(partida => partida.id === partidaRow.idPartidaCatalogo)[0].clave : null}>
                          <TableCell component="th" scope="row">
                            {partidasParanoid.filter(partida => partida.id === partidaRow.idPartidaCatalogo)[0] ? partidasParanoid.filter(partida => partida.id === partidaRow.idPartidaCatalogo)[0].clave : null}
                          </TableCell>
                          <TableCell>{partidasParanoid.filter(partida => partida.id === partidaRow.idPartidaCatalogo)[0] ? partidasParanoid.filter(partida => partida.id === partidaRow.idPartidaCatalogo)[0].concepto : null}</TableCell>
                          <TableCell align="right"><NumberFormat value={Number(partidaRow.montoMaximo).toFixed(2)} displayType={'text'} decimalScale={2} thousandSeparator={true} prefix={'$'} /></TableCell>
                          <TableCell align="right">
                            <NumberFormat value={Number(partidaRow.prioridad1).toFixed(2)} displayType={'text'} decimalScale={2} thousandSeparator={true} prefix={'$'} />
                          </TableCell>
                          <TableCell align="right">
                            <NumberFormat value={Number(partidaRow.prioridad2).toFixed(2)} displayType={'text'} decimalScale={2} thousandSeparator={true} prefix={'$'} />
                          </TableCell>

                          <Can I="update, delete" a="partidaProyecto" ability={ability}>

                            {(idUsuario === idResponsable && elaboracionInforme !== 2) ? <TableCell align="left" style={{ width: 20 }}>
                              <ButtonGroup disableElevation variant="outlined" color="primary">
                                <Can I="update" a="partidaProyecto" ability={ability}>
                                  <Button variant='contained' color='inherit' id={`enviar${row.id}`} onClick={() => handleUpdate(partidaRow)} disabled={loading}>Editar</Button>
                                </Can>
                                <Can I="delete" a="partidaProyecto" ability={ability}>
                                  <Button variant='contained' style={{ marginLeft: 5, backgroundColor: "darkred", color: 'white' }} onClick={() => handleDelete(partidaRow.idPartidaProyecto, row)} disabled={loading}>Eliminar</Button>
                                </Can>
                              </ButtonGroup>
                            </TableCell> : <></>}

                          </Can>
                        </TableRow>
                        : <></>
                    ))}
                  </TableBody>
                </Table>
              }
              {idUsuario === idResponsable && isNaN(planeacion)?
                <form onSubmit={(e) => (handleSubmit(e, row))} name={`guardar${row.id}`}>
                  <Grid container justifyContent='space-between' spacing={2}>
                    <Grid item><Autocomplete
                      disablePortal
                      isOptionEqualToValue={(option, value) => `${option.concepto}` === `${value.concepto}`}
                      options={partidas}
                      fullWidth
                      onChange={(event, newValue) => {
                        setNuevaPartidaProyecto({ ...nuevaPartidaProyecto, [`idPartidaCatalogo`]: newValue ? newValue.id : null })
                        const clavePartida = newValue.clave
                        if (clavePartida && (Number(clavePartida) < Number(6000000) && Number(clavePartida) >= Number(5000000))) {
                          if (process.env.REACT_APP_MINIMO_ACTIVO_FIJO && Number(montoMaximo) < Number(process.env.REACT_APP_MINIMO_ACTIVO_FIJO)) {
                            setSeverity('warning')
                            setMensaje(`El monto mínimo para que se considere activo fijo es  ${format({ prefix: '$' })(Number(process.env.REACT_APP_MINIMO_ACTIVO_FIJO).toFixed(2))}`)
                            setOpenMensaje(true)
                            setMontoExcedido(true)
                            return;
                          }
                          else {
                            setMontoExcedido(false)
                            setOpenMensaje(false)
                          }
                        }
                        else {
                          setMontoExcedido(false)
                          setOpenMensaje(false)
                        }

                        // console.log(`${event.target.name} ${newValue ? newValue.id : null} ${newValue ? newValue.clave : null}`)
                      }}
                      value={nuevaPartidaProyecto.idPartidaCatalogo ? partidas.filter(partidas => partidas.id === nuevaPartidaProyecto.idPartidaCatalogo)[0] : null}
                      getOptionLabel={(option) => `${option.clave}-${option.concepto}`}
                      sx={{ width: 500, marginTop: 5 }}
                      renderInput={(params) => <TextField required {...params} label="Partida" focused variant='outlined' multiline name='idPartidaCatalogo' />}
                    /></Grid><br />
                    {elaboracionInforme < 2 ?
                      <>
                        <Grid item>
                          {editing ?
                            <input name="idPartidaProyecto" value={nuevaPartidaProyecto.idPartidaProyecto} type='hidden' /> :
                            <></>}


                          <TextField required sx={{ width: 150, marginTop: 5 }} name='montoMaximo' label="Presupuesto inicial" onChange={(e) => {

                            const valor = e.target.value
                            const nombre = e.target.name
                            const valorNumerico = Math.abs(valor.replace(/,/g, ''))
                            setNuevaPartidaProyecto({ ...nuevaPartidaProyecto, [nombre]: valor, 'prioridad1': Number(Number(valorNumerico) * Number(porcentajePrioridad1)).toFixed(2), 'prioridad2': Number(Number(valorNumerico) * Number(porcentajePrioridad2)).toFixed(2) })
                            const montoMaximo = valor.replace(/,/g, '')
                            setMontoMaximo(montoMaximo)
                            // console.log(`Monto maximo  ${montoMaximo} >  ${(Number(row.montoDisponible) + Number(nuevaPartidaProyecto.montoPrevio ? nuevaPartidaProyecto.montoPrevio : 0))} `)
                            //console.log(`process.env.REACT_APP_MINIMO_ACTIVO_FIJO ${Number(process.env.REACT_APP_MINIMO_ACTIVO_FIJO)}`)
                            // console.log(`Number(montoMaximo) ${Number(montoMaximo)}`)
                            const clavePartida = nuevaPartidaProyecto.idPartidaCatalogo ? partidas.filter(partidas => partidas.id === nuevaPartidaProyecto.idPartidaCatalogo)[0].clave : null
                            //console.log(`clavePartida ${clavePartida}`)
                            if (clavePartida && (Number(clavePartida) < Number(6000000) && Number(clavePartida) >= Number(5000000))) {
                              if (process.env.REACT_APP_MINIMO_ACTIVO_FIJO && Number(montoMaximo) < Number(process.env.REACT_APP_MINIMO_ACTIVO_FIJO)) {
                                setSeverity('warning')
                                setMensaje(`El monto mínimo para que se considere activo fijo es  ${format({ prefix: '$' })(Number(process.env.REACT_APP_MINIMO_ACTIVO_FIJO).toFixed(2))}`)
                                setOpenMensaje(true)
                                setMontoExcedido(true)
                                e.target.style.color = 'red'
                                return;
                              }
                              else {
                                e.target.style.color = 'black'
                                setMontoExcedido(false)
                                setOpenMensaje(false)
                              }
                            }
                            else {
                              e.target.style.color = 'black'
                              setMontoExcedido(false)
                              setOpenMensaje(false)
                            }

                            if (Number(montoMaximo) > Number((Number(row.montoDisponible) + Number(nuevaPartidaProyecto.montoPrevio ? nuevaPartidaProyecto.montoPrevio : 0)).toFixed(2))) {
                              setSeverity('error')
                              setMensaje(`El monto asignado a la partida ${format({ prefix: '$' })(Number(montoMaximo).toFixed(2))} no puede superar al monto disponible del proyecto ${format({ prefix: '$' })((Number(row.montoDisponible) + Number(nuevaPartidaProyecto.montoPrevio ? nuevaPartidaProyecto.montoPrevio : 0)).toFixed(2))}`)
                              setOpenMensaje(true)
                              setMontoExcedido(true)
                              e.target.style.color = 'red'
                              return;
                            }
                            else {
                              e.target.style.color = 'black'
                              setMontoExcedido(false)
                              setOpenMensaje(false)
                            }
                            // console.log(`row.prioridad1Disponible ${row.prioridad1Disponible} < (valorNumerico * porcentajePrioridad1) ${valorNumerico * porcentajePrioridad1}`)
                            if (Number((Number(row.prioridad1Disponible) + Number(nuevaPartidaProyecto.prioridad1MontoPrevio ? nuevaPartidaProyecto.prioridad1MontoPrevio : 0)).toFixed(2)) < Number((valorNumerico * porcentajePrioridad1).toFixed(2))) {
                              setSeverity('error')
                              setMensaje(`El monto de la prioridad 1 ${format({ prefix: '$' })(Number(valorNumerico * porcentajePrioridad1).toFixed(2))} no puede superar al monto disponible de la prioridad1 del proyecto ${format({ prefix: '$' })(Number(Number(row.prioridad1Disponible) + Number(nuevaPartidaProyecto.prioridad1MontoPrevio ? nuevaPartidaProyecto.prioridad1MontoPrevio : 0)).toFixed(2))}`)
                              setOpenMensaje(true)
                              setMontoExcedido(true)
                              document.forms['guardar' + row.id]['prioridad1'].style.color = 'red'
                              return
                            }
                            else {
                              setOpenMensaje(false)
                              setMontoExcedido(false)
                              document.forms['guardar' + row.id]['prioridad1'].style.color = 'black'
                            }
                            if (Number((Number(row.prioridad2Disponible) + Number(nuevaPartidaProyecto.prioridad2MontoPrevio ? nuevaPartidaProyecto.prioridad2MontoPrevio : 0)).toFixed(2)) < Number((valorNumerico * porcentajePrioridad2).toFixed(2))) {
                              setSeverity('error')
                              setMensaje(`El monto de la prioridad 2 ${format({ prefix: '$' })(Number(Number(valorNumerico) * Number(porcentajePrioridad2)).toFixed(2))} no puede superar al monto disponible de la prioridad 2 del proyecto ${format({ prefix: '$' })((Number(row.prioridad2Disponible) + Number(nuevaPartidaProyecto.prioridad2MontoPrevio ? nuevaPartidaProyecto.prioridad2MontoPrevio : 0)).toFixed(2))}`)
                              setOpenMensaje(true)
                              setMontoExcedido(true)
                              document.forms['guardar' + row.id]['prioridad2'].style.color = 'red'
                              return
                            }
                            else {
                              setOpenMensaje(false)
                              setMontoExcedido(false)
                              document.forms['guardar' + row.id]['prioridad2'].style.color = 'black'
                            }
                          }} InputProps={{
                            inputComponent: NumberFormatMoney,
                            startAdornment: (
                              <InputAdornment position="start">
                                $
                              </InputAdornment>
                            ),
                          }} value={nuevaPartidaProyecto.montoMaximo} />
                        </Grid>
                        <Grid item>
                          <TextField required sx={{ width: 150, marginTop: 5 }} name='prioridad1' label="Prioridad 1"
                            onChange={async (e) => {
                              const montoMaximoPrioridad1 = Number(Number(row.prioridad1Disponible) + Number(nuevaPartidaProyecto.prioridad1MontoPrevio ? nuevaPartidaProyecto.prioridad1MontoPrevio : 0))
                              const montoMaximoPrioridad2 = Number(Number(row.prioridad2Disponible) + Number(nuevaPartidaProyecto.prioridad2MontoPrevio ? nuevaPartidaProyecto.prioridad2MontoPrevio : 0))

                              verificarPrioridad(e.target, montoMaximoPrioridad1, 'prioridad2', 1, document.forms['guardar' + row.id]['prioridad2'],
                                montoMaximoPrioridad2, 2)
                            }} InputProps={{
                              inputComponent: NumberFormatMoney,
                              startAdornment: (
                                <InputAdornment position="start">
                                  $
                                </InputAdornment>
                              ),
                            }} value={nuevaPartidaProyecto.prioridad1} />
                        </Grid>
                        <Grid item>
                          <TextField required sx={{ width: 150, marginTop: 5 }} name='prioridad2'
                            onChange={async (e) => {
                              const montoMaximoPrioridad1 = Number(Number(row.prioridad1Disponible) + Number(nuevaPartidaProyecto.prioridad1MontoPrevio ? nuevaPartidaProyecto.prioridad1MontoPrevio : 0))
                              const montoMaximoPrioridad2 = Number(Number(row.prioridad2Disponible) + Number(nuevaPartidaProyecto.prioridad2MontoPrevio ? nuevaPartidaProyecto.prioridad2MontoPrevio : 0))

                              verificarPrioridad(e.target, montoMaximoPrioridad2, 'prioridad1', 2, document.forms['guardar' + row.id]['prioridad1'],
                                montoMaximoPrioridad1, 1)
                            }} label="Prioridad 2" InputProps={{
                              inputComponent: NumberFormatMoney,
                              startAdornment: (
                                <InputAdornment position="start">
                                  $
                                </InputAdornment>
                              ),
                            }} value={nuevaPartidaProyecto.prioridad2} />
                        </Grid></> : <></>
                    }
                    <Grid item>
                      <Button variant='contained' color='primary' type='submit' style={{ width: 200, marginTop: 40 }} disabled={montoExcedido || loading}>
                        {elaboracionInforme < 2 ? 'Asignar Presupuesto' : 'Agregar'}
                      </Button>
                      {elaboracionInforme < 2 ?
                        <Button variant='contained' onClick={(e) => {
                          //Limpiar el formulario
                          nuevaPartidaProyecto.prioridad2 = ''
                          nuevaPartidaProyecto.prioridad1 = ''
                          nuevaPartidaProyecto.montoMaximo = ''
                          nuevaPartidaProyecto.idPartidaCatalogo = ''
                          nuevaPartidaProyecto.montoPrevio = 0
                          nuevaPartidaProyecto.prioridad1MontoPrevio = 0
                          nuevaPartidaProyecto.prioridad2MontoPrevio = 0
                          //Eliminar banderas y ocultar mensajes
                          setMontoExcedido(false)
                          setOpenMensaje(false)
                          setEditing(false)
                          document.forms['guardar' + row.id]['montoMaximo'].style.color = 'black'
                          document.forms['guardar' + row.id]['prioridad1'].style.color = 'black'
                          document.forms['guardar' + row.id]['prioridad2'].style.color = 'black'
                          //nuevaPartidaProyecto.idPartidaCatalogo = null
                          //Limpiar el Autocomplete
                          document.forms['guardar' + row.id].getElementsByClassName('css-1glvl0p-MuiButtonBase-root-MuiIconButton-root-MuiAutocomplete-clearIndicator')[0].click()
                        }} color='primary' type='button' style={{ width: 150, marginTop: 40, marginLeft: 20 }} id={`limpiar${row.id}`} disabled={loading}>
                          Cancelar
                        </Button>
                        : <></>
                      }
                    </Grid>
                  </Grid>
                </form> : <></>
              }
              <Box sx={{ width: '100%' }}>
                <Collapse in={openMensaje}>
                  <Alert severity={severity}
                    action={
                      <IconButton
                        aria-label="close"
                        color="inherit"
                        size="small"
                        onClick={() => {
                          setOpenMensaje(false);
                        }}
                      >
                        <CloseIcon fontSize="inherit" />
                      </IconButton>
                    }
                    style={{ marginTop: 30 }}
                  >
                    {mensaje}
                  </Alert>
                </Collapse>
              </Box>

            </Box>
          </Collapse>
        </TableCell>
      </StyledTableRow>
    </>
  );
}

Row.propTypes = {
  row: PropTypes.shape({
    clave: PropTypes.string.isRequired,
    descripcion: PropTypes.string.isRequired,
    montoAsignado: PropTypes.number.isRequired,
    montoMaximo: PropTypes.number.isRequired,
    montoDisponible: PropTypes.number.isRequired,
    prioridad1: PropTypes.number.isRequired,
    prioridad1Asignada: PropTypes.number.isRequired,
    prioridad1Disponible: PropTypes.number.isRequired,
    prioridad2: PropTypes.number.isRequired,
    prioridad2Asignada: PropTypes.number.isRequired,
    prioridad2Disponible: PropTypes.number.isRequired,
    partidaProyectos: PropTypes.arrayOf(
      PropTypes.shape({
        clave: PropTypes.number,
        concepto: PropTypes.string,
        montoMaximo: PropTypes.number,
        montoDisponible: PropTypes.number,
        prioridad1: PropTypes.number,
        prioridad1Asignada: PropTypes.number,
        prioridad1Disponible: PropTypes.number,
        prioridad2: PropTypes.number,
        prioridad2Asignada: PropTypes.number,
        prioridad2Disponible: PropTypes.number
      }),
    ),

  }).isRequired,
};



export default function ProyectosInforme() {

  const token = sessionStorage.getItem('token')
  const decoded = jwt_decode(token);
  const obtenerReglas = () => {
    let reglas
    const perfilElegido = sessionStorage.getItem('perfilElegido')
    switch (perfilElegido) {
      case 'asistente':
        reglas = decoded.rulesAsistente
        break
      case 'investigador':
        reglas = decoded.rulesJefaturaArea
        break
      case 'coordinacion':
        reglas = decoded.rulesCoordinacion
        break
      case 'jefe':
        reglas = decoded.rulesJefatura
        break
      case 'administracion':
        reglas = decoded.rulesAdministracionProyecto
        break
      default:
        break
    }
    return reglas
  }
  let reglas = decoded.rules
  if (!reglas)
    reglas = obtenerReglas(decoded)
  //console.log(`rules ${JSON.stringify(reglas)}`)
  const ability = new Ability(reglas);
  const idResponsable = decoded.id;
  const [proyectos, setProyectos] = useState([])
  const [partidas, setPartidas] = useState([]);
  const [partidasParanoid, setPartidasParanoid] = useState([]);
  const [tienePermisos, setTienePermisos] = useState(false)

  const params = useParams()
  //el idResponsable recibido en params es el usuario consultado
  //el idResponsable decodificado es el usuario logeado
  //http://localhost:${process.env.REACT_APP_BACKEND_PORT}/usuarios/41280

  const planeacion = params.planeacion;

  const verificarDepto = async () => {
    //console.log(`Usuario Solicitado ${params.idResponsable} Usuario Logueado ${idResponsable}`)
    if (Number(params.idResponsable) === Number(idResponsable)) {
      //console.log('TIENE PERMISO DE VER SÓLO SUS PROYECTOS')
      return true
    }
    else {
      for (let i = 0; i < reglas.length; i++) {

        if (reglas[i].action === 'jefatura' && reglas[i].subject === 'departamento') {
          //console.log('TIENE PERMISOS PARA VER LAS PARTIDAS DE TODO EL DEPTO.')

          return true
        }



        if (reglas[i].action === 'direccion' && reglas[i].subject === 'division') {
         // console.log('TIENE PERMISOS PARA VER LAS PARTIDAS DE TODA LA DIVISIÓN.')

          return true
        }
        if (reglas[i].action === 'rectoria' && reglas[i].subject === 'unidad') {
          //console.log('TIENE PERMISOS PARA TODO')

          return true
        }
      }
      return false
    }
  }
  const [permitido] = useState(verificarDepto())
 
  const cargarProyectos = async () => {

    let solicitud = `http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/informeProyecto/proyectos/${params.idResponsable}/${planeacion}/${sessionStorage.getItem('idEntidad')}`
    
    //console.log(`isCoordinacion ${isCoordinacion}`)
    /* if (Boolean(isCoordinacion)){
       const resEntidad = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/entidad/${sessionStorage.getItem('idEntidad')}`, {
           method: "GET",
           headers: {
             "Content-Type": "application/json",
             "x-access-token": sessionStorage.getItem('token'),
             "perfil": sessionStorage.getItem('perfil')
           }
         })
 
         const entidadLeida = await resEntidad.json()
         solicitud=`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/informeProyecto/proyectosGestion/${params.idResponsable}/${entidadLeida.idEntidadSuperior}`
       
     }*/
    const res = await fetch(solicitud, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": sessionStorage.getItem('token'),
        "perfil": sessionStorage.getItem('perfil')
      }
    })
    if (res.status === 404) {
      //console.log('regresó 404 en ProyectosInforme')
      return
    }
    else {
      //console.log('si hay proyectos')
      const data = await res.json()

      //console.log(data)
      setProyectos(data)
    }
  }
  const cargarPartidas = async () => {
    const res = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/partidas`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": sessionStorage.getItem('token'),
        "perfil": sessionStorage.getItem('perfil')
      }
    })
    const partidas = await res.json()

    setPartidas(partidas);

    // Cargar partidas aunque hayan sido borradas para el desplegado en el listado de partidas de proyecto
    const resParanoid = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/partidas/paranoid`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": sessionStorage.getItem('token'),
        "perfil": sessionStorage.getItem('perfil')
      }
    })
    const partidasParanoid = await resParanoid.json()

    setPartidasParanoid(partidasParanoid);
  }

  useEffect(() => {
    (async () => {
      const isPermitido = await permitido
      if (isPermitido) {
        setTienePermisos(true)
        await cargarProyectos()
        await cargarPartidas()

      }
    })()
  }, [])
  return (
    <>
      <Link to="/partidas" style={{ marginTop: 50, marginBottom: 20, textDecoration: 'none', color: '#AD25A8' }}><Button variant='outlined' color='inherit' style={{ marginTop: 50, marginBottom: 20 }}>Catálogo de Partidas</Button></Link>
      <Tooltip title="Si no encuentras la partida que buscas puedes agregarla al catálogo desde esta opción" arrow>
        <TipsAndUpdatesTwoToneIcon sx={{ color: 'orange' }} />
      </Tooltip>
      <TableContainer component={Paper} sx={{ marginTop: 5 }}>
        <Table aria-label="collapsible table">
          {tienePermisos ?
            (proyectos && proyectos.length > 0 ? <TableHead>
              <TableRow>
                <TableCell />
                <TableCell align="center">Clave</TableCell>
                <TableCell align="center">Proyecto</TableCell>
                <TableCell align="right" style={{ whiteSpace: 'pre' }}>Presupuesto inicial</TableCell>
                <TableCell align="right" style={{ whiteSpace: 'pre' }}>Presupuesto asignado</TableCell>
                <TableCell align="right" style={{ whiteSpace: 'pre' }}>Presupuesto disponible</TableCell>
              </TableRow>

            </TableHead> : <TableHead>
              <TableRow>
                <TableCell align='center' sx={{ fontSize: 20 }}>Aún no tiene proyectos presupuestales asignados</TableCell>
              </TableRow>
            </TableHead>)
            : <TableHead>
              <TableRow>
                <TableCell align='center' sx={{ fontSize: 20 }}>No tiene permisos para ver este informe</TableCell>
              </TableRow>
            </TableHead>}



          <TableBody>
            {proyectos.map ? proyectos.map((row) => (
              <Row key={row.clave} row={row} partidas={partidas} partidasParanoid={partidasParanoid} ability={ability} idUsuario={idResponsable} idResponsable={params.idResponsable} planeacion={planeacion}/>
            )) : <></>}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
}